import IqosXDiplomaArta from './IqosXDiplomaArta';
export default IqosXDiplomaArta;
